// extracted by mini-css-extract-plugin
export default {"glass":"style_glass__8zLsf","tyre":"style_tyre__H3C8-"};